<template>
  <div class="bet-status-icon">
    <div
      v-if="status === 'pending'"
      class="status-dot status-pending"
      :title="$t('pending')"
    ></div>

    <svg
      v-else-if="status === 'win'"
      class="status-icon status-win"
      fill="currentColor"
      viewBox="0 0 20 20"
      :title="$t('win')"
    >
      <path
        fill-rule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
        clip-rule="evenodd"
      />
    </svg>

    <svg
      v-else-if="status === 'lose'"
      class="status-icon status-lose"
      fill="currentColor"
      viewBox="0 0 20 20"
      :title="$t('lose')"
    >
      <path
        fill-rule="evenodd"
        d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
        clip-rule="evenodd"
      />
    </svg>

    <svg
      v-else-if="status === 'void'"
      class="status-icon status-void"
      fill="currentColor"
      viewBox="0 0 20 20"
      :title="$t('void')"
    >
      <path
        fill-rule="evenodd"
        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
        clip-rule="evenodd"
      />
    </svg>

    <svg
      v-else-if="status === 'cancelled'"
      class="status-icon status-cancelled"
      fill="currentColor"
      viewBox="0 0 20 20"
      :title="$t('cancelled')"
    >
      <path
        fill-rule="evenodd"
        d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
        clip-rule="evenodd"
      />
    </svg>

    <svg
      v-if="halfWon"
      class="status-icon status-win half-icon"
      fill="currentColor"
      viewBox="0 0 20 20"
      :title="$t('halfWon')"
    >
      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
    </svg>

    <svg
      v-if="halfLost"
      class="status-icon status-lose half-icon"
      fill="currentColor"
      viewBox="0 0 20 20"
      :title="$t('halfLost')"
    >
      <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'BetStatusIcon',
  props: {
    status: {
      type: String,
      required: true
    },
    halfWon: {
      type: Boolean,
      default: false
    },
    halfLost: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: 'md'
    }
  }
};
</script>

<style scoped>
.bet-status-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.status-dot {
  width: 16px;
  height: 16px;
  border-radius: 50%;
}

.status-pending {
  background-color: var(--mybets-status-pending, #eab308);
  animation: status-pulse 2s ease-in-out infinite;
}

.status-icon {
  width: 16px;
  height: 16px;
}

.status-win { color: var(--mybets-status-win, #22c55e); }
.status-lose { color: var(--mybets-status-lose, #ef4444); }
.status-void { color: var(--mybets-status-void, #3b82f6); }
.status-cancelled { color: var(--mybets-status-cancelled, #eab308); }

.half-icon {
  margin-left: 4px;
}

@keyframes status-pulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.5; }
}
</style>
